import { ActionButtonProps, Box, BoxProps, ColorOptions, Form, Loader, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ListNew } from '../../components/ListNew'
import { SearchFilter } from '../../components/SearchFilter'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { CardForm } from './CardForm'
import { formData } from './formData'

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}

const CardMapping = () => {
  const [enableDetails, setDetails] = useState(false)
  const { getCardByEntityId, getCardsData, add, getEntityNameMap, fetchCodeNames, entityMap, accessConfig } = useStores(
    (store) => ({
      getCardByEntityId: store.card.getCardByEntityId,
      getCardsData: store.card.getCardsData(),
      length: store.card.cardList.length,
      add: store.card.add,
      getEntityNameMap: store.entityMaster.getEntityNameMap,
      fetchCodeNames: store.user.fetchCodeNames,
      entityMap: store.entityMaster.getEntityMap(),
      accessConfig: store.user.getAccessConfig(['entity_config', 'card_type_mapping']),
    }),
  )

  const [isExpanded, setisExpanded] = useState<{ isExpanded: boolean; value: number }>({ isExpanded: false, value: -1 })
  const [card, setCard] = useState({})
  const resetFormRef = useRef<any>(null)
  const [search, setSearch] = useState('')

  const [getCardsById, getCardsByIdHandler] = useLazyApiData(getCardByEntityId)
  const [lazyAdd, lazyAddHandler] = useLazyApiData(add)
  const [lazyEntityIdName, lazyEntityIdNameHandler] = useLazyApiData(getEntityNameMap)
  const [lazyFetchCardSchemaApi, lazyFetchCardSchemaHandler] = useLazyApiData(fetchCodeNames)
  const [lazyFetchCardTypeApi, lazyFetchCardTypeHandler] = useLazyApiData(fetchCodeNames)

  const handleActions = ({ values, title, defaultActionButtonOnSubmit, resetForm }: ActionButtonProps) => {
    resetFormRef.current = resetForm
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box paddingTop={8} align={'center'} justify={'center'}>
        <ButtonNew
          title={title}
          onPress={handleOnPress}
          isLoading={lazyAddHandler.state === 'pending'}
          height={40}
          width={280}
          color={'#214796' as ColorOptions}
          titleColor={'WHITE'}
          textType={'bodyMedium14'}
          paddingHorizontal={36}
        />
      </Box>
    )
  }

  const addCard = (data: any) => {
    lazyAdd(data)
  }

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    // { id: 'ID' },
    { entityID: 'Entity ID' },
    { scheme: 'Scheme', isSortable: true },
    { cardType: 'Cardtype', isSortable: true },
    { status: 'Status' },
  ]

  useEffect(() => {
    if (getCardsByIdHandler.state === 'fulfilled') {
      setDetails(true)
    }
  }, [card, getCardsByIdHandler, getCardsData])

  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled') {
      console.log('added card')
      resetFormRef?.current({})
    }
  }, [lazyAddHandler])

  useEffect(() => {
    lazyEntityIdName()
    lazyFetchCardSchemaApi('CARD_SCHEME')
    lazyFetchCardTypeApi('CARD_TYPE')
  }, [lazyEntityIdName, lazyFetchCardSchemaApi, lazyFetchCardTypeApi])

  const onCardPress = ({ item }: any, index: number) => {
    console.log({ item })
    setCard(item)
    isAccessible(accessConfig, 'update') &&
      setisExpanded({ isExpanded: !isExpanded.isExpanded, value: isExpanded.value === item?.id ? -1 : item?.id })
  }

  const fetchDataFromServer = useCallback(
    (_, paginationInfo) => getCardsById(search, paginationInfo),
    [getCardsById, search],
  )

  const renderList = () => {
    if (!enableDetails) {
      return null
    }

    const getExpandView = () => {
      return (
        <CardForm
          cardMapping={card}
          onUpdate={onUpdate}
          isDeletable={isAccessible(accessConfig, 'delete')}
          onClose={() => setisExpanded({ isExpanded: false, value: -1 })}
        />
      )
    }
    console.log('getCardsByIdHandler?.data?.content', getCardsByIdHandler?.data)
    return (
      <Box>
        <Spacer direction={'vertical'} size={24} />
        {search && (
          <ListNew
            keyExtractor={keyExtractor}
            headTitle={headTitles}
            sizeConfig={[2.5, 2.5, 2.5, 2.5]}
            data={getCardsByIdHandler?.data?.content}
            onRowItemClick={onCardPress}
            listTitle={'Card Mapping List'}
            showExpandArrow={true}
            expandView={getExpandView}
            isExpanded={isExpanded.isExpanded}
            expandedIndex={isExpanded.value}
            fetchDataFromServer={fetchDataFromServer}
            apiHandler={getCardsByIdHandler}
            updatedPaginationInfo={{
              ...(getCardsByIdHandler?.data?.pageNo !== undefined && { page: getCardsByIdHandler?.data?.pageNo }),
              ...(getCardsByIdHandler?.data?.totalElements !== undefined && {
                total: getCardsByIdHandler?.data?.totalElements,
              }),
            }}
            dbCollumnMapper={{
              entityID: 'entityId',
            }}
          />
        )}
      </Box>
    )
  }

  const onSearch = (data: any) => {
    setSearch(data?.search)
    getCardsById(data?.search, { page: 1, size: 10 })
  }

  const onUpdate = () => {
    getCardsById(search)
    setisExpanded({ isExpanded: false, value: -1 })
  }

  return (
    <Box>
      {isAccessible(accessConfig, 'fetch') && <SearchFilter onSearch={onSearch} placeholder={'Search By Entity Id'} />}
      {getCardsByIdHandler.state === 'pending' && <Loader />}
      {renderList()}
      <Spacer direction={'vertical'} size={24} />
      {isAccessible(accessConfig, 'add') && (
        <>
          <Box {...styles.topContainer} bg={'#f8f9fc' as ColorOptions}>
            <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={'Add New Mapping'} />
          </Box>
          <Box {...styles.formContainer}>
            <Form
              formData={formData(addCard, entityMap, lazyFetchCardSchemaHandler?.data, lazyFetchCardTypeHandler?.data)}
              actionButtons={handleActions}
              container={FormBox}
            />
          </Box>
        </>
      )}
    </Box>
  )
}

export default CardMapping

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  container: {
    ...shadow,
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    padding: 24,
  } as BoxProps,
  topContainer: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  formContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
}
